<div class="trip_booking_package_info flex-col flex-gap-16 mt-16 mb-16">
  <div class="flex-row flex-gap-4 items-center justify-start">
    <mat-icon class="text-color-light-blue">shopping_bag</mat-icon>
    @if (productType) {
      <span class="font-size-14 font-weight-500 text-color-black">{{productType}} - </span>
    }
    @if (inputTripBookingPackage.product.description) {
      <span class="font-size-14 font-weight-500 text-color-black">{{inputTripBookingPackage.product.description}}</span>
    }
  </div>
  <div class="trip_booking_package_info flex-col flex-wrap flex-gap-44">
    @if (inputTripBookingPackage.product.product_type == 'esim-manet') {
      <div class="flex-row flex-gap-16 items-center justify-start">
        @if (inputTripBookingPackage.product.data.provider) {
          <div class="trip_booking_package_info_attribute">
            <span class='ml-4 mr-4'>{{'Provider' | translate}}: {{inputTripBookingPackage.product.data.provider}}</span>
          </div>
        }
        @if (inputTripBookingPackage.product.data.need_activation_date) {
          <div class="ml-8 trip_booking_package_info_attribute" >
            <div>{{'Data di attivazione' | translate }}: {{ $safeNavigationMigration(inputTripBookingPackage?.target_info?.date) | date }}</div>
          </div>
        }
      </div>
    }
    @if (mix) {
      @if (inputTripBookingPackage.booking_status === 'canceled') {
        <div>
          <span class="red-fg">{{'Cancellata' | translate}}</span>
        </div>
      }
      @if (inputTripBookingPackage.booking_status === 'confirmed') {
        <div>
          <span class="green-fg">{{'Confermata' | translate}}</span>
        </div>
      }
    }
    <div class=" flex-row justify-between font-weight-700">
      <span class=" value price font-size-14 text-color-black">{{totalRowLordo | currency:'EUR' }}</span>
    </div>
  </div>
</div>
